import React, { HTMLAttributes, memo, type ReactNode } from 'react'
import { BannerStyled, type ThemeName } from './Banner.styles'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Icon } from '@mobi/component-library/Assets/Icon'
import BannerIcon from './BannerIcon'

type Props = {
  type?: ThemeName
  text: string
  button?: ReactNode
  hideIcon?: boolean
  onClickDismiss?: () => void
} & HTMLAttributes<HTMLDivElement>

export const Banner = memo<Props>(
  ({ text, type = 'neutral', button, hideIcon = false, onClickDismiss, ...props }) => {
    return (
      <BannerStyled type={type} {...props}>
        {!hideIcon && <BannerIcon theme={type} />}

        <p>{text}</p>

        {button}

        {onClickDismiss && (
          <Button
            onClick={() => onClickDismiss()}
            color='tertiary_grey'
            size='sm'
            isIconOnlyButton
            name='close_button'
            aria-label='Dismiss banner'
          >
            <Icon name='SolidXClose' color='inherit' />
          </Button>
        )}
      </BannerStyled>
    )
  }
)

Banner.displayName = 'Banner'
